import { computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { selectProductIdAdditionalPrefixRexExp } from '@epicuro-next/platform/configuration';
import {
  selectProductIdsFieldsRule,
  selectProductTitleFieldsRule,
  selectShowPCardMarkup,
  selectShowWspdPriceRule,
} from '@epicuro-next/state/p-basket-state';
import { selectShowWholeSalePrices } from '@epicuro-next/state/user-state';
import { signalStoreFeature, withComputed, withProps } from '@ngrx/signals';
import { select, Store } from '@ngrx/store';

export function withPcardSettingStoreFeature() {
  return signalStoreFeature(
    withProps((_, store = inject(Store)) => ({
      _showMarkup: toSignal(store.select(selectShowPCardMarkup), {
        initialValue: false,
      }),
      _showWholeSalePriceUserSetting: toSignal(
        store.pipe(select(selectShowWholeSalePrices)),
        {
          initialValue: true,
        },
      ),
      productIdAdditionalPrefixRexExp: toSignal(
        store.select(selectProductIdAdditionalPrefixRexExp),
      ),
      showWspdPrice: toSignal(store.select(selectShowWspdPriceRule), {
        initialValue: false,
      }),
      titleFields: toSignal(store.select(selectProductTitleFieldsRule)),
      idFields: toSignal(store.select(selectProductIdsFieldsRule)),
    })),
    withComputed(({ _showMarkup, _showWholeSalePriceUserSetting }) => {
      return {
        showWholeSalePrices: computed(
          () => !_showMarkup() && !!_showWholeSalePriceUserSetting(),
        ),
        showMarkupPrice: computed(() =>
          Boolean(_showMarkup() && _showWholeSalePriceUserSetting()),
        ),
      };
    }),
  );
}
